import FormController from './form_controller';

export default class extends FormController {
  static values = { completedFootprint: Boolean };

  confirmSubmit(event) {
    if (this.completedFootprintValue && !window.confirm(this.completedFootprintMessage())) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    if (this.hasFutureYearOnlySelection() && !window.confirm(this.futureYearOnlyMessage())) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  hasFutureYearOnlySelection() {
    return this.formTarget.querySelector('option:checked[data-future-year-only="true"]') !== null;
  }

  completedFootprintMessage() {
    return this.translate(
      'completed_footprint',
      'If you edit this consumption there is a chance the emission factor will be updated.'
    );
  }

  futureYearOnlyMessage() {
    return this.translate(
      'future_year_only',
      'There is no emission factor consistent with the reporting year for the selected options, ' +
        'but one exists for later years. If you continue, this entry will be saved with emission ' +
        '"Not available".'
    );
  }

  // Le traduzioni arrivano da `window.LocaleData` (i18n_loader), non da un valore per form.
  translate(key, fallback) {
    const translations = window.LocaleData && window.LocaleData.translations;
    const messages = translations && translations[window.Locale];
    const message = messages && messages.shared && messages.shared.warn_consumption;

    return (message && message[key]) || fallback;
  }
}
